import type { ButtonName } from '@coursera/event-pulse-types';

export const COURSERA_TEAMS_POPULAR_DOMAINS_MAPPING = [
  { id: 'data-analysis', name: 'Data Analysis' },
  { id: 'generative-ai', name: 'Generative AI' },
  { id: 'machine-learning', name: 'Machine Learning' },
  { id: 'python-programming', name: 'Python Programming' },
  { id: 'cloud-computing', name: 'Cloud Computing' },
  { id: 'project-management', name: 'Project Management' },
];

// Mapping of domain IDs to chip event names
export const CHIP_EVENT_NAME_MAPPING: Record<string, ButtonName> = {
  'data-analysis': 'ent_website_search_chip_data_analysis',
  'generative-ai': 'ent_website_search_chip_generative_ai',
  'machine-learning': 'end_website_search_chip_machine_learning',
  'python-programming': 'ent_website_search_chip_python_programming',
  'cloud-computing': 'ent_website_search_chip_cloud_computing',
  'project-management': 'ent_website_search_chip_project_management',
} as const;
